module.exports = __webpack_public_path__ + "img/4.304044d9.jpeg";